import templateUrl from 'emun.salesrep/show-daily-appointments.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config';

class ShowDailyAppointmentsController {
  constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
    let $ctrl = this;
    var context = $ctrl.context || 'rep';

    $ctrl.activityType = "Show Appointment";
    $ctrl.year = $ctrl.market.year; //new Date().getFullYear();
    $ctrl.numAppointmentsGoal = 0;
    $ctrl.dollarAmountGoal = 0;

    this.activities = {
      total: 0,
      count: 0
    };

    var repFilter = "";
    if (context !== 'executive') {
      var filterType = "SalesRep";
      if (context === 'ManagerId') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }

    filterType = "username";
    repFilter = "";
    if (context !== 'executive') {
      if (context === 'ManagerId') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }
    $ctrl.chartData = [];
    $ctrl.chartLabels = [];
    $ctrl.appointments = [];
    //		$ctrl.chartSeries = ['Appointments', 'Projected $'];
    $ctrl.avgAppointment = 0;

    $ctrl.loadChartData = function (args) {
      $ctrl.chartData.push($ctrl.appointments);
      $ctrl.chartData.push($ctrl.projections);
      //$ctrl.chartData = [];
      //$ctrl.chartData.push([$ctrl.activities.count]);
      //$ctrl.chartData.push([$ctrl.numAppointmentsGoal]);
      $ctrl.chartLoaded = true;
    }


    this.activitiesCount = createAutoQuery({
      url: 'QueryShowAppointmentsByDay.json?showCode=' + $ctrl.market.showCode + '&dateRange=calendar&Sum=Appointments&groupBy=ShowCode,ShowDay&orderBy=ShowCode,ShowDay',
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (total) {
          $ctrl.chartLabels.push(moment.utc(total.showDay).format("dddd"));
          //					$ctrl.chartLabels.push([moment(total.showDay).format("ddd"),moment(total.showDay).format("MM/DD")]);
          $ctrl.appointments.push(total.appointments);
        });
        if ($ctrl.market.projectionDollar > 0) {
          $ctrl.avgAppointment = $ctrl.market.projectionDollar
          $ctrl.projections = [];
          $ctrl.appointments.forEach(function (a) {
            $ctrl.projections.push(Math.round(a * $ctrl.avgAppointment));
          });
          $ctrl.loadChartData();
        } else {
          $ctrl.weeklyAverageQuery = createAutoQuery({
            url: 'QueryWeeklyBookingAverageShow?count=weeknumber&sum=WeekAvg&WeekAvgLessThan=1000000&GroupBy=SalesRep&showcode=' + $ctrl.market.projectionShowCode,
            pageSize: 1000,
            autoLoad: true,
            onLoaded: function (avgArgs) {
              var totalavg = 0
              avgArgs.results.forEach(function (result) {
                totalavg += result.sumWeekAvg / result.countweeknumber;
              });
              $ctrl.avgAppointment = totalavg / avgArgs.total;
              $ctrl.projections = [];
              $ctrl.appointments.forEach(function (a) {
                $ctrl.projections.push(Math.round(a * $ctrl.avgAppointment));
              });
              $ctrl.loadChartData();
            }
          });
        }
      }
    });


    var gfilterType = "SalesRepID";
    var gfilter = "";
    if (context !== 'executive') {
      if (context === 'ManagerId') {
        gfilterType = 'ManagerId';
      }
      gfilter = gfilterType + "=" + $ctrl.rep.id;
    }

    $ctrl.chartColors = salesrepConfig.chartColors;

    $ctrl.datasetOverride = [
      {
        yAxisID: "y-axis-1",
        label: "Appointments",
        borderWidth: 1,
        type: 'line'
      },
      {
        yAxisID: "y-axis-2",
        label: "Projected $",
        borderWidth: 1,
        type: 'line'
      }
    ];


    $ctrl.colors = salesrepConfig.chartColors;
    $ctrl.chartOptions = {
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 5,
          fontSize: 10
        }
      },
      elements: {
        rectangle: {
          borderWidth: 1
        }
      },
      scales: {
        yAxes: [
          {
            id: 'y-axis-1',
            type: 'linear',
            display: true,
            position: 'left'
          },
          {
            id: 'y-axis-2',
            type: 'linear',
            display: true,
            position: 'right',
            ticks: {
              callback: function (value, index, values) {
                return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
            }
          }
        ]
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            return label + ": " + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        }
      },
    }


  }
}

let ShowDailyAppointments = {
  bindings: {
    rep: '<',
    context: '@',
    showcode: '@',
    market: '<'
  },
  controller: ShowDailyAppointmentsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}


export default ShowDailyAppointments